import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { setting } from '../../../../setting';
import * as moment from "moment";
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { RestService } from '../rest.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

moment.locale('es');

@Component({
  selector: 'usb-material-modal-confirm',
  templateUrl: './material-modal-confirm.component.html',
  styleUrls: ['./material-modal-confirm.component.scss'],
})
export class MaterialModalConfirmComponent implements OnInit {

  public comparisonRouteImagenLogo: any;
  public paymentData: any[] = [];
  public paymentModal: any;
  public message: string = '';
  public origin: string;
  public currencyItinerary: string;
  public feePayment: number = 0;
  public agencies: any[];
  public agencyImagenDynamic: string;
  public clientSetting: any;
  public currencyAgency: any;
  public currencies: any;
  styleSidebar: any;

  public confirmResult: Subject<any> = new Subject<any>();
  _formSelectAgency: FormGroup;
  routeStorage: string = '';
  backgroundSelect: any;
  buttonColorActive: string = '';
  buttonTextActive: string = '';
  associatePax: any;
  clientGlobalSetting: any;
  showCopyButton: boolean = false;
  copyData: { endpoint: string, body: any } = null;
  copySuccess: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MaterialModalConfirmComponent>,
    public userService: UserService,
    public bsModalRef: BsModalRef,
    private restService: RestService,
    private formBuilder: FormBuilder,
    public toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.clientSetting = JSON.parse(localStorage.getItem(setting.name));
    this.clientGlobalSetting = this.clientSetting?.clients_setting_global;
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body)?.card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    this.routeStorage = setting.apiStorageBooking;
    this.comparisonRouteImagenLogo = setting.apiStorageBooking;

    if (this.paymentModal) {
      this.feePayment = this.paymentModal.feePayment;
      this.paymentData = this.paymentModal.payment;
    }

    if (this.message && this.origin === 'clients') {
      this.data.message = this.message;
    }

    if (this.message && this.origin !== 'clients') {
      this.data.message = this.message;
    }

    if (this.data?.associatePax) {
      this.associatePax = this.data.associatePax;
    }

    if (this.data?.profile === 'seller') {
      this.initForm();
      this.getAgencyAll();
      this.agencyImagenDynamic = 'assets/img/sin-logo.png';
    }

    if (this.data?.showCopyButton) {
      this.showCopyButton = true;
      this.copyData = this.data.copyData || null;
    }
  }

  get agencyImagen(): string {
    const agencyImagen = this.userService._imagen_logotype;
    if (agencyImagen === this.comparisonRouteImagenLogo || agencyImagen === '') {
      return 'assets/img/sin-logo.png';
    }
    return agencyImagen;
  }

  initForm(): void {
    this._formSelectAgency = this.formBuilder.group({
      agencyId: new FormControl(null, Validators.required)
    });
  }

  confirm(): void {
    if (this.data?.profile === 'seller') {
      if (this._formSelectAgency.valid) {
        this.confirmResult.next({ success: true, agencyId: this._formSelectAgency.get('agencyId').value });
        this.bsModalRef.hide();
        this.dialogRef.close({ success: true, agencyId: this._formSelectAgency.get('agencyId').value });
      } else {
        this.toastr.info('Seleccione una agencia');
      }
    } else {
      this.confirmResult.next(true);
      if (this.data?.type === 'material') {
        this.dialogRef.close(true);
      }
      if (this.data?.profile === 'seller') {
        this.dialogRef.close(true);
      } else {
        this.bsModalRef.hide();
      }
    }
  }

  decline(): void {
    this.confirmResult.next(false);
    if (this.data?.type === 'material') {
      this.dialogRef.close(false);
    }
    if (this.data?.profile === 'seller') {
      this.dialogRef.close(false);
    } else {
      this.bsModalRef.hide();
    }
  }

  copyToClipboard(): void {
    if (!this.copyData) return;

    const textToCopy = `ENDPOINT: ${this.copyData.endpoint}\n\nBODY: ${JSON.stringify(this.copyData.body, null, 2)}`;

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.copySuccess = true;
      setTimeout(() => {
        this.copySuccess = false;
      }, 3000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  getAgencyAll(): void {
    this.restService.doGet('app', 'allAgencies').subscribe({
      next: (res: any) => {
        if (res && res?.data) {
          res.data.forEach((agency: any) => {
            if (agency?.imagen_logotype) {
              agency.imagen_logotype = `${this.routeStorage}${agency.imagen_logotype}`;
            }
          });

          this.agencies = res.data.filter(c => c.currency !== null && c.id_agency_external === null);
          this.agencies.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        }
      },
      error: (error: HttpErrorResponse) => {}
    });
  }

  changeAgency(id: number): void {
    if (!id) return;

    const agency = this.agencies?.find(c => Number(c.id) === Number(id));
    this.agencyImagenDynamic = agency?.imagen_logotype || 'assets/img/sin-logo.png';
  }
}